import type { KeyboardEvent } from 'react';

import { MODAL_BASE_PRIMARY_BUTTON_STYLE, MODAL_BASE_SECONDARY_BUTTON_STYLE, ModalBase } from '../../Widgets/ModalBase';
import { DEFAULT_ORG_SETTING_DIALOG_STYLES, OrgSettingDialogStyles } from './orgSettingDialogStyles';

interface OrgSettingDialogProps {
  title: string;
  message: string;
  toggleLabel: string;
  busy: boolean;
  onToggle: () => void;
  onReset: () => void;
  onCancel: () => void;
  styles?: OrgSettingDialogStyles;
}

/** Choosing an option here is the confirmation: there is no second "are you sure". */
export const OrgSettingDialog = (
  { title, message, toggleLabel, busy, onToggle, onReset, onCancel, styles = DEFAULT_ORG_SETTING_DIALOG_STYLES }: OrgSettingDialogProps,
) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key !== 'Escape' || busy) return;
    event.stopPropagation();
    onCancel();
  };

  return (
    <div role='dialog' aria-modal='true' aria-label={title} onKeyDown={handleKeyDown}>
      <ModalBase
        title={title}
        onOverlayClick={busy ? undefined : onCancel}
        actions={
          <>
            <button type='button' css={MODAL_BASE_SECONDARY_BUTTON_STYLE} disabled={busy} onClick={onCancel} autoFocus>{'Cancel'}</button>
            <button type='button' css={MODAL_BASE_SECONDARY_BUTTON_STYLE} disabled={busy} onClick={onReset}>{'Reset to default'}</button>
            <button type='button' css={MODAL_BASE_PRIMARY_BUTTON_STYLE} disabled={busy} onClick={onToggle}>{toggleLabel}</button>
          </>
        }
      >
        <p css={styles.message}>{message}</p>
      </ModalBase>
    </div>
  );
};
